/* eslint-disable react/jsx-fragments */
/* eslint-disable react/prop-types */
import React, { useState, useEffect, Fragment } from 'react';
import { injectIntl } from 'react-intl';
import { decodeText } from 'app/utils/strings';

import { MathJaxContext, MathJax } from 'better-react-mathjax';

import messages from '../onlineSimulatedMessages';
import './QuestionCard.scss';

const QuestionCard = (props) => {
  const {
    question,
    questionOptional,
    intl,
    alternativeAnswered,
    handleBtnNavigation,
    totalQuestions,
    user,
    hasEssay,
  } = props;
  const letter = ['a', 'b', 'c', 'd', 'e'];
  const [alternativeSelected, setAlternativeSelected] = useState('');
  const [idAlternative, setIdAlternative] = useState(null);
  const [buttonENActive, setButtonENActive] = useState(true);
  const [buttonESActive, setButtonESActive] = useState(false);

  function parseMedia(text) {
    return text ? text.replace(/\/cp\/cpdata\/uploads/g, process.env.REACT_APP_FILES_API) : '';
  }

  function handleAnswerSelected(answer, id, status = '') {
    setAlternativeSelected(answer);
    setIdAlternative(id);
    if (status !== 'load') {
      alternativeAnswered(answer || null, id);
    }
  }

  function handleShowQuestion(lang) {
    if (lang === 'en') {
      setButtonENActive(true);
      setButtonESActive(false);
    } else {
      setButtonENActive(false);
      setButtonESActive(true);
    }
  }

  useEffect(() => {
    let alternative = '';
    if (question && question.answer) {
      alternative = question.alternatives.find((el) => el.id === question.answer && el.position);
    }
    handleAnswerSelected(alternative.position, alternative.id, 'load');
  }, [question]);

  return (
    <div style={{ textAlign: 'left' }}>
      <br />
      {question && (
        <MathJaxContext>
          <div className="d-flex align-items-center justify-content-between mb-3">
            <strong style={{ backgroundColor: '#eee', padding: '5px' }}>
              {intl.formatMessage(messages.question)} {question.position}
            </strong>

            {questionOptional && user.idType <= 3 && (
              <div className="d-flex align-items-center">
                <button
                  type="button"
                  className={`navQuestionBtn back-btn mr-2 ${buttonENActive ? 'active' : ''}`}
                  onClick={() => handleShowQuestion('en')}
                >
                  {intl.formatMessage(messages.english)}
                </button>
                <button
                  type="button"
                  className={`navQuestionBtn back-btn ${buttonESActive ? 'active' : ''}`}
                  onClick={() => handleShowQuestion('es')}
                >
                  {intl.formatMessage(messages.spanish)}
                </button>
              </div>
            )}
          </div>
          <div className="row">
            <div className="col-lg-12">
              {user.idType > 3 && (
                <MathJax dynamic="true">
                  <div
                    className="fixText"
                    dangerouslySetInnerHTML={{ __html: parseMedia(decodeText(question.text)) }}
                  />
                </MathJax>
              )}

              {((user.idType <= 3 && !questionOptional) ||
                (user.idType <= 3 && questionOptional && buttonENActive)) && (
                <MathJax dynamic="true">
                  <div
                    className="fixText"
                    dangerouslySetInnerHTML={{ __html: parseMedia(decodeText(question.text)) }}
                  />
                </MathJax>
              )}
              {user.idType <= 3 && questionOptional && buttonESActive && (
                <MathJax dynamic="true">
                  <div
                    className="fixText"
                    dangerouslySetInnerHTML={{
                      __html: parseMedia(decodeText(questionOptional.text)),
                    }}
                  />
                </MathJax>
              )}
              <br />

              {user.idType > 3 && (
                <div className="fixAlternative">
                  {intl.formatMessage(messages.selectOption)}:
                  {question.alternatives &&
                    question.alternatives.map((el) => (
                      <label htmlFor={`alternative${letter[el.position - 1]}`}>
                        <input
                          className="form-check-input"
                          type="radio"
                          name={`alternative${letter[el.position - 1]}`}
                          value={el.position}
                          id={`alternative${letter[el.position - 1]}`}
                          onChange={() => handleAnswerSelected(el.position, el.id)}
                          checked={alternativeSelected === el.position}
                          disabled={alternativeSelected || user.idType <= 3}
                        />
                        {letter[el.position - 1]})
                        <MathJax dynamic="true">
                          <div
                            className="marginAlternative"
                            style={{ display: 'inline' }}
                            dangerouslySetInnerHTML={{ __html: parseMedia(decodeText(el.text)) }}
                          />
                        </MathJax>
                      </label>
                    ))}
                  {user.idType > 3 && (
                    <button
                      type="button"
                      className="clearChoiceButton"
                      onClick={() => handleAnswerSelected('')}
                    >
                      {intl.formatMessage(messages.clearChoice)}
                    </button>
                  )}
                </div>
              )}

              {((user.idType <= 3 && !questionOptional) ||
                (user.idType <= 3 && questionOptional && buttonENActive)) && (
                <div className="fixAlternative">
                  {intl.formatMessage(messages.selectOption)}:
                  {question.alternatives &&
                    question.alternatives.map((el) => (
                      <label htmlFor={`alternative${letter[el.position - 1]}`}>
                        <input
                          className="form-check-input"
                          type="radio"
                          name={`alternative${letter[el.position - 1]}`}
                          value={el.position}
                          id={`alternative${letter[el.position - 1]}`}
                          onChange={() => handleAnswerSelected(el.position, el.id)}
                          checked={alternativeSelected === el.position}
                          disabled={alternativeSelected || user.idType <= 3}
                        />
                        {letter[el.position - 1]})
                        <MathJax dynamic="true">
                          <div
                            className="marginAlternative"
                            style={{ display: 'inline' }}
                            dangerouslySetInnerHTML={{ __html: parseMedia(decodeText(el.text)) }}
                          />
                        </MathJax>
                      </label>
                    ))}
                </div>
              )}

              {user.idType <= 3 && questionOptional && buttonESActive && (
                <div className="fixAlternative">
                  {intl.formatMessage(messages.selectOption)}:
                  {questionOptional.alternatives &&
                    questionOptional.alternatives.map((el) => (
                      <label htmlFor={`alternative${letter[el.position - 1]}`}>
                        <input
                          className="form-check-input"
                          type="radio"
                          name={`alternative${letter[el.position - 1]}`}
                          value={el.position}
                          id={`alternative${letter[el.position - 1]}`}
                          onChange={() => handleAnswerSelected(el.position, el.id)}
                          checked={alternativeSelected === el.position}
                          disabled={alternativeSelected || user.idType <= 3}
                        />
                        {letter[el.position - 1]})
                        <MathJax dynamic="true">
                          <div
                            className="marginAlternative"
                            style={{ display: 'inline' }}
                            dangerouslySetInnerHTML={{ __html: parseMedia(decodeText(el.text)) }}
                          />
                        </MathJax>
                      </label>
                    ))}
                </div>
              )}
            </div>
          </div>
          <div className="d-flex gap justify-content-end mt-5">
            {question.position > 1 && (
              <button
                type="button"
                className="navQuestionBtn"
                onClick={() =>
                  handleBtnNavigation(parseInt(question.position) - 1, 'prev', idAlternative)
                }
              >
                {intl.formatMessage(messages.previousQuestion)}
              </button>
            )}
            {question.position < totalQuestions ? (
              <button
                type="button"
                className="navQuestionBtn"
                onClick={() =>
                  handleBtnNavigation(parseInt(question.position) + 1, 'next', idAlternative)
                }
              >
                {intl.formatMessage(messages.nextQuestion)}
              </button>
            ) : question.position >= totalQuestions && hasEssay ? (
              <button
                type="button"
                className="navQuestionBtn"
                onClick={() =>
                  handleBtnNavigation(parseInt(question.position), 'essay', idAlternative)
                }
              >
                {intl.formatMessage(messages.startComposing)}
              </button>
            ) : (
              <Fragment>
                {user.idType > 3 && (
                  <button
                    type="button"
                    className="navQuestionBtn"
                    onClick={() =>
                      handleBtnNavigation(parseInt(question.position), 'finish', idAlternative)
                    }
                  >
                    {intl.formatMessage(messages.finishAttempt)}
                  </button>
                )}
              </Fragment>
            )}
          </div>
        </MathJaxContext>
      )}
    </div>
  );
};

QuestionCard.propTypes = {};

QuestionCard.defaultProps = {};

export default injectIntl(QuestionCard);
